import React, { FC } from 'react';
import { calculateRotatedPivotedNodePos } from './KTileItem';
import { getKTileStyle, getPivotStyle } from './KTileAsset';
import { KTileDef } from '@envclient/envengine/src/envs/koenigsburg/KTileGameConfig';
import { getKTileDef } from '../../config/kTileMapConfig';
import { KResource } from '@envclient/envengine/src/envs/koenigsburg/KResource';
import { KResourceItem } from './KResourceItem';
import { KTileDTO, ResourceMove } from '@envclient/envengine/src/envs/koenigsburg/KTile';

interface KResourcePhaseProps {
  active: boolean;
  tileData: KTileDTO[];
  resources: Map<number, ResourceMove>;
  handleResourceClick: (resource: KResource) => void;
}

const KResourcePhase: FC<KResourcePhaseProps> = ({ active, tileData, resources, handleResourceClick }) => {
  if (!active) return null;

  return (
    <>
      {Array.from(resources.values()).map((resourceMove) => {
        const { resource, selectedNode } = resourceMove;
        let meeplePos: { left: number; top: number } = { left: 0, top: 0 };
        // use targetNode coords to calc meeplePos
        // selectedNode is the port node where the token entered the city
        if (selectedNode) {
          const t = tileData.find((t) => t.id === selectedNode.tile.id);
          if (!t) return null;
          const ts = getKTileStyle(t.place);
          const left: number = +ts.left.substring(0, ts.left.length - 2);
          const top: number = +ts.top.substring(0, ts.top.length - 2);
          const tileDef: KTileDef = getKTileDef(t.type);
          const nodes = tileDef.nodes;
          const meepleNode = nodes.find((node) => node.id === selectedNode.id);
          const pivotStyle = getPivotStyle(t.place);
          const meepleRot = +pivotStyle.transform.match(/(\d+)/)?.[0] || 0;
          meeplePos = calculateRotatedPivotedNodePos(meepleNode, meepleRot, t.rot, t.shape);
          meeplePos.left += left;
          meeplePos.top += top;
        } else {
          // use resourceNode coords
          const t = tileData.find((t) => t.id === resource.tileId);
          if (!t || !t.resource) return null;
          const ts = getKTileStyle(t.place);
          const left: number = +ts.left.substring(0, ts.left.length - 2);
          const top: number = +ts.top.substring(0, ts.top.length - 2);
          const tileDef: KTileDef = getKTileDef(t.type);
          // find resource node coords in canvas system
          const nodes = tileDef.nodes;
          const meepleNode = nodes.find((node) => node.id === resource.nodeId);
          const pivotStyle = getPivotStyle(t.place);
          const meepleRot = +pivotStyle.transform.match(/(\d+)/)?.[0] || 0;
          meeplePos = calculateRotatedPivotedNodePos(meepleNode, meepleRot, t.rot, t.shape);
          meeplePos.left += left;
          meeplePos.top += top;
        }
        return <KResourceItem key={resource.id} pos={meeplePos} resource={resource} selected />;
      })}
    </>
  );
};

export default KResourcePhase;
